import clsx from 'clsx';
import { useMergedStyles } from 'hooks/useMergedStyles';
import { FC } from 'react';
import { Styles } from 'types/styles';
import styles from './RegularText.module.scss';

type Props = { newStyles: Styles; additionalClass?: string };
const RegularText: FC<Props> = ({ newStyles = {}, additionalClass = '', children }) => {
  const mergedStyles = useMergedStyles(styles, newStyles);

  return (
    <div
      className={clsx(mergedStyles['regular-text'], {
        [additionalClass]: additionalClass,
      })}
    >
      {children}
    </div>
  );
};

export default RegularText;
